import { render } from "./UpdateAgent.vue?vue&type=template&id=d68f856c&scoped=true"
import script from "./UpdateAgent.vue?vue&type=script&lang=js"
export * from "./UpdateAgent.vue?vue&type=script&lang=js"

import "./UpdateAgent.vue?vue&type=style&index=0&id=d68f856c&scoped=true&lang=css"

import exportComponent from "C:\\xampp\\htdocs\\ms\\ms-by-bimms\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d68f856c"]])

export default __exports__